import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-equipment',
  templateUrl: './handover-equipment.component.html',
  styleUrls: ['./handover-equipment.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandoverEquipmentComponent implements OnInit {

  @Input() model?: HandoverModel;

  get hasEquipment(): boolean {
    return this.model?.equipmentItems != null && this.model?.equipmentItems.length > 0;
  }

  constructor() {
  }

  ngOnInit(): void {
  }

}
